import React from "react";
import ImportRecordsStepsHeader from './ImportRecordsStepsHeader.js';
import ImportRecordsStep from './ImportRecordsStep.js';
import AssignCustomerDetails from './AssignCustomerDetails.js';
import ModalButtons from "../ModalButtons/ModalButtons";
import AssignReservationDetails from './AssignReservationDetails';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default class PropertyRecordsImporter extends React.Component{
  constructor(props){
    super(props)

    this.state = {
      loading: false, 
      importRecordType: null,
      importedFile: null,
      file_name: null,
      fileHeaders: null,
      step: 'record-type',
      errors: [],
      customer: {
        salutation: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        address_1: '',
        address_2: '',
        city: '',
        state: '',
        country: '',
        postal_code: '',
        marketing_opt_in: '',
      },
      reservation: {
        booked_at: '',
        start_date: '',
        end_date: '',
        booked_at_format: '',
        start_date_format: '',
        end_date_format: '',
        rate: '',
        rate_default: '',
        email: '',
        customer_first_name: '',
        customer_last_name: '',
        room_type_name: '',
        room_type_name_default: '',
        confirmation_number: '',
        revenue_no_tax: '',
        payment_amount: '',
        tax_name_1: '',
        tax_name_1_default: '',
        taxes_amount_1: '',
        tax_name_2: '',
        tax_name_2_default: '',
        taxes_amount_2: '',
        tax_name_3: '',
        tax_name_3_default: '',
        taxes_amount_3: '',
        fee_name: '',
        fee_name_default: '',
        fees_amount: '',
        room_id: '',
        check_in_time: '',
        check_out_time: '',
        adults: '',
        children: '',
        notes: null,
        source_type: '',
        source: '',
        taxable: '',
        generate_housekeeping: ''
      }
    }
  };

  render(){
    return(
      <div className="PropertyRecordsImporter" >
        <LoadingSpinner show={this.state.loading} />
        {!this.state.importRecordType ? this.renderChooseRecordType() : this.renderImportSteps() }
      </div>
    );
  };

  renderChooseRecordType = () => {
    return(
      <div className="ChooseRecordType-wrapper">
        <div className="row">
          <div className="col-md text-center">
            <span className="ss-heartuser"></span>
            <h3>{I18n.t('customers')}</h3>
            <button className="btn btn-primary btn-sm" type="button" onClick={(e) => this.onChangeImportType('customers', e)}>{I18n.t('import_customers')}</button>
          </div>
          <div className="col-md text-center">
            <span className="ss-contacts"></span>
            <h3>{I18n.t('reservations')}</h3>
            <button className="btn btn-primary btn-sm" type="button" onClick={(e) => this.onChangeImportType('reservations', e)}>{I18n.t('import_reservations')}</button>
          </div>
        </div>
      </div>
    );
  };

  renderImportSteps (){
    return(
      <div className="import-records-steps-wrapper">
        <ModalButtons loading={this.state.loading} buttons={this.buttons()} />
        <ImportRecordsStepsHeader {...this.state} />
        {this.state.step == 'import-file' ? <ImportRecordsStep {...this.props} {...this.state} onFileUploaded={this.onFileUploaded} onChangeFileName={this.onChangeFileName} /> : null}
        {this.state.step == 'assign-columns' ? this.renderColumnDetailsStep() : null}
      </div>
    );
  };

  renderColumnDetailsStep() {
    if(this.state.importRecordType == 'customers') {
      return(
        <AssignCustomerDetails {...this.props} {...this.state} onChange={this.onChangeCustomer}/>
      );
    } else if (this.state.importRecordType == 'reservations'){
      return (
        <AssignReservationDetails {...this.props} {...this.state} onChange={this.onChangeReservation} onChangeNotes={this.onChangeNotes} selectTaxes={this.selectTaxes} />
      );
    };
  };

  onChangeFileName = (file_name) => {
    this.setState({file_name: file_name})
  }

  onFileUploaded = (value, name) => {
    $.ajax({
      type: 'POST',
      url: this.props.parse_headers_path,
      data: {
        file_upload: value,
        file_upload_name: name,
        import_type: this.state.importRecordType,
        property_id: this.props.property.id,
      }
    }).done((data) => {
      if (this.state.importRecordType && this.state.importRecordType == "customers") {
        for (var i = 0; i < this.props.customer_imports.length; i++) {
          if (this.props.customer_imports[i].csv_name == data.file_upload_name) {
            if (this.props.customer_imports[i].previous_columns) {
              this.setState({customer: this.props.customer_imports[i].previous_columns})
              break;
            }
          }
          if (i == this.props.customer_imports.length - 1) {
            this.setState({customer: {
              salutation: '',
              first_name: '',
              middle_name: '',
              last_name: '',
              email: '',
              phone_number: '',
              address_1: '',
              address_2: '',
              city: '',
              state: '',
              country: '',
              postal_code: '',
              marketing_opt_in: '',
            }})
          }
        }
      } else if (this.state.importRecordType) {
        for (var i = 0; i < this.props.reservation_imports.length; i++) {
          if (this.props.reservation_imports[i].csv_name == data.file_upload_name) {
            if (this.props.reservation_imports[i].previous_columns) {
              this.setState({reservation: this.props.reservation_imports[i].previous_columns})
              break;
            }
          }
          if (i == this.props.reservation_imports.length - 1) {
            this.setState({reservation: {
              booked_at: '',
              start_date: '',
              end_date: '',
              booked_at_format: '',
              start_date_format: '',
              end_date_format: '',
              rate: '',
              rate_default: '',
              email: '',
              customer_first_name: '',
              customer_last_name: '',
              room_type_name: '',
              room_type_name_default: '',
              confirmation_number: '',
              revenue_no_tax: '',
              payment_amount: '',
              tax_name_1: '',
              tax_name_1_default: '',
              taxes_amount_1: '',
              tax_name_2: '',
              tax_name_2_default: '',
              taxes_amount_2: '',
              tax_name_3: '',
              tax_name_3_default: '',
              taxes_amount_3: '',
              fee_name: '',
              fee_name_default: '',
              fees_amount: '',
              room_id: '',
              check_in_time: '',
              check_out_time: '',
              adults: '',
              children: '',
              notes: null,
              source_type: '',
              source: '',
              taxable: '',
              generate_housekeeping: ''
            }})
          }
        }
      }

      this.setState({importedFile: data.file_upload, fileHeaders: data.column_headers})
    });
  };

  buttons = () => {
    if (this.state.step === 'import-file') {
      return(
        [
          {
            name: I18n.t('cancel'),
            html_attributes: [
              'data-dismiss="modal"'
            ]
          },
          {
            name: I18n.t('next'),
            button_classes: ['primary'],
            html_attributes: [this.state.file_name == null ? 'disabled' : ''],
            onClick: (e) => {
              e.stopPropagation();
              e.preventDefault();

              this.setState({step: 'assign-columns'})
            }
          }
        ]
      );
    } else if (this.state.step === 'assign-columns'){
      return(
        [
          {
            name: I18n.t('cancel'),
            html_attributes: [
              'data-dismiss="modal"'
            ]
          },
          {
            name: I18n.t('validate_records'),
            button_classes: ['primary'],
            onClick: (e) => {
              e.stopPropagation();
              e.preventDefault();

              this.onGenerateRecords();
            }
          }
        ]
      );
    } else {

  return [
          {
            name: I18n.t('ok'),
            html_attributes: [
              'data-dismiss="modal"'
            ]
          },
        ];

    };

  };

  onGenerateRecords() {
    this.setState({loading: true})

    $.ajax({
      type: 'POST',
      url: this.generateRecordsURL(),
      data: {
        property_id: this.props.property.id,
        file_upload: this.state.importedFile,
        customer: this.state.customer,
        reservation: this.state.reservation,
      }
    }).done((data) => {
      if (Object.keys(data.errors).length) {
        this.setState({errors: data.errors, loading: false})
      } else {
        this.setState({loading: false});

        parent.refresh_data(I18n.t('import_ran_successfully'));

        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    });
  };

  onChangeCustomer = (e) => {
    var customer = Object.assign({}, this.state.customer);
    customer[e.target.name] = e.target.value;

    this.setState({ customer: customer });
  };

  onChangeReservation = (e) => {
    var reservation = Object.assign({}, this.state.reservation);
    reservation[e.target.name] = e.target.value;

    this.setState({ reservation: reservation });
  };

  onChangeNotes = (e, name) => {
    var reservation = Object.assign({}, this.state.reservation);
    var columns = []

    e.map((column) => {
      columns.push(column.text)
    })
    
    if (columns.length == 0) {
      reservation[name] = null
    } else {
      reservation[name] = columns
    }
    
    this.setState({ reservation: reservation });
  }

  onChangeImportType = (import_type) => {
    var importedFile = null;
    var file_name = null;
    var fileHeaders = null;
    var customer = this.state.customer;
    var reservation = this.state.reservation;
    
    if (import_type == "customers") {
      importedFile = this.props.customer_file_upload
      file_name = this.props.customer_file_name
      fileHeaders = this.props.customer_column_headers
      if (this.props.customer) {
        customer = this.props.customer
      }
    } else {
      importedFile = this.props.reservation_file_upload
      file_name = this.props.reservation_file_name
      fileHeaders = this.props.reservation_column_headers
      if (this.props.reservation) {
        reservation = this.props.reservation
      }
    }

    this.setState({ importRecordType: import_type, step: 'import-file', importedFile: importedFile, file_name: file_name, fileHeaders: fileHeaders, customer: customer, reservation: reservation})
  }

  generateRecordsURL = () => {
    if (this.state.importRecordType === "customers") {
      return this.props.process_customers;
    } else if (this.state.importRecordType === "reservations") {
      return this.props.process_reservations;
    };
  };

  selectTaxes = (taxes) => {
    var reservation = Object.assign({}, this.state.reservation);
    reservation.taxes = taxes;

    this.setState({ reservation: reservation });
  };

};